
const EventSystem = {
  // 🔥 Publish custom event
  publish(eventName, data = {}) {
    const event = new CustomEvent(eventName, { detail: data });
    window.dispatchEvent(event);
    // console.log(`📤 Event Published: ${eventName}`, data);
  },

  // 👂 Subscribe (like addEventListener)
  subscribe(eventName, callback) {
    window.addEventListener(eventName, (event) => {
      callback(event.detail);
    });
    // console.log(`👂 Subscribed to: ${eventName}`);
  }
};